import Meter from './meter';
import TypeUtils from '@/helpers/type-utils';

export default class StatsConsumptionResponse<T> {
  meter: Meter;
  values: T[];

  static map<T>(data: Partial<StatsConsumptionResponse<T>>): StatsConsumptionResponse<T> | null {
    if (!data) {
      return null;
    }

    const statistics = new StatsConsumptionResponse<T>();

    statistics.meter = TypeUtils.hasObjectOrDefault(data.meter);
    statistics.values = TypeUtils.hasArrayOrDefault(data.values)

    return statistics;
  }

}
